import BasicContentCTAButton from './BasicContentCTAButton';

export { type BasicContentCTAButtonProps } from './BasicContentCTAButton';
export default BasicContentCTAButton;
